$(() => {
	
	if ($(".block-bannercarousel").length > 0) {

		$(".block-bannercarousel").each((i, el) => {
			let bannerCarousel = $(el).find(".banner-carousel");
			let autoplay = bannerCarousel.data("autoplay");
			let autoplayInterval = bannerCarousel.data("interval");

			const navPrev =
				'<svg xmlns="http://www.w3.org/2000/svg" width="15" height="30" viewBox="0 0 15 30" fill="none"><path d="M12.7388 30L0 15L12.7388 0L15 2.6625L4.52229 15L15 27.3375L12.7388 30Z" fill="#1C1B1F"/></svg>';
			const navNext =
				'<svg xmlns="http://www.w3.org/2000/svg" width="15" height="30" viewBox="0 0 15 30" fill="none"><path d="M2.26115 -7.93683e-07L15 15L2.26115 30L2.62826e-06 27.3375L10.4777 15L4.71102e-07 2.6625L2.26115 -7.93683e-07Z" fill="#1C1B1F"/></svg>';

			bannerCarousel.owlCarousel({
				loop: true,
				navText: [navPrev, navNext],
				autoHeight: false,
				autoplay: (typeof autoplay === 'undefined') ? false : autoplay,
				autoplayTimeout: autoplayInterval,
				items: 1,
				margin: 0,
				responsive: {
					0: {
						dots: true,
						nav: false
					},
					992: {
						dots: false,
						nav: true
					}
				},
			});
		});

	}
});
